import { render } from "./unifiChild3.vue?vue&type=template&id=00242bae&scoped=true"
import script from "./unifiChild3.vue?vue&type=script&lang=js"
export * from "./unifiChild3.vue?vue&type=script&lang=js"

import "./unifiChild3.vue?vue&type=style&index=0&id=00242bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00242bae"]])

export default __exports__